<script>
	export let room;
	export let initPage;
//자동매칭 룸 정보 획득 
</script>

<!-- S : PAGE[2] - 게임 시작 -->
<div class="game-modal-wrap" class:on={room.gameStatus === 'quick'} data-modal="start">
	<div class="modal start">
		<div class="txt-box">
			<p class="title">자동 매칭 중...</p>
			<p class="desc">자동매칭 참가자를 기다리는 중 입니다</p>
		</div>
		<div class="btn-wrap">
			<div class="info">대기중... <strong>{room.players}/6명</strong></div>
			<button type="button" class="btn gray-border" on:click={initPage}>취소</button>
		</div>
	</div>
</div>
<!-- E : PAGE[2] - 게임 시작 -->

<style lang="scss">
</style>